{
    "coordinates": [
        -19.55541876385942,
        125.32702506945822
    ],
    "tooltip": "Gogo",
    "title": "Gogo Formation",
    "country": "Australia",
    "period": "Devonian",
    "alt": "TODO"
}
